/*
 * @Description: 导出excle，后端返回数据流
 * @Author: fely
 * @Date: 2020-06-22 14:12:06
 * @LastEditTime: 2020-08-05 17:33:46
 * @LastEditors: fely
 */
import axios from 'axios'
import qs from "qs";
import { getTocken } from '../utils/auth'
export function exportMethod(urlText, dataText, filename) {
    axios({
            method: "post",
            data: qs.stringify(dataText),
            url: urlText,
            responseType: "blob",
        headers: { Authorization: getTocken() },
        })
        .then((res) => {
            const link = document.createElement("a");
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);

            // link.download = res.headers['content-disposition'] //下载后文件名
            link.download = filename; //下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((error) => {
            this.$Notice.error({
                title: "错误",
                desc: "网络连接错误",
            });
            console.log(error);
        });
}